/*
 * Product add-ons / order upsell
 * -----------------------------------------------------------------------------
 * Drives the "product_addons" block. Lives in an asset so it works for markup
 * injected at runtime (Quick view). The popup is portaled to <body> only when
 * inside a modal/drawer (Quick view) so it survives that container closing.
 *
 * Add detection does NOT depend on the theme's cart drawer or count badge:
 *   1) window.fetch / XMLHttpRequest are wrapped to detect /cart/add completing.
 *   2) /cart.js is polled as an authoritative backup.
 * The cart drawer is stopped from flashing open via Bootstrap's cancelable
 * show.bs.offcanvas while an add-triggered popup is in flight.
 *
 * Debug: append ?addons_debug=1 to the URL to log each step to the console.
 */
(function () {
  var routes = (window.Shopify && window.Shopify.routes) || {};
  var ADD_URL = (routes.cart_add_url || '/cart/add') + '.js';
  var ROOT_URL = routes.root_url || '/';
  if (ROOT_URL.charAt(ROOT_URL.length - 1) !== '/') ROOT_URL += '/';

  var W = (window.JhangoAddons = window.JhangoAddons || { bound: false });

  var DEBUG = /[?&]addons_debug/.test(location.search);
  function log() { if (DEBUG) console.log.apply(console, ['[addons]'].concat([].slice.call(arguments))); }

  /* --------------------------------------------------------------- cart glue */

  function addToCart(variantId, qty) {
    return fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function refreshCart() {
    return fetch(ROOT_URL + '?sections=offcanvas-cart', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['offcanvas-cart'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#offcanvas-cart');
        var current = document.querySelector('#offcanvas-cart');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var titleSpan = (fresh || document).querySelector('.offcanvas-title span');
        if (titleSpan) {
          var count = titleSpan.textContent.trim();
          document.querySelectorAll('.cart-count-badge').forEach(function (b) {
            b.textContent = count; b.setAttribute('data-count', count);
          });
        }
      })
      .catch(function () {});
  }

  function fetchCount() {
    return fetch(ROOT_URL + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c && typeof c.item_count === 'number' ? c.item_count : null; })
      .catch(function () { return null; });
  }
  function badgeCount() {
    var b = document.querySelector('.cart-count-badge[data-count]');
    if (b) return parseInt(b.getAttribute('data-count'), 10) || 0;
    var s = document.querySelector('#offcanvas-cart .offcanvas-title span');
    return s ? (parseInt(s.textContent, 10) || 0) : 0;
  }

  function bs(name) { return window.bootstrap ? window.bootstrap[name] : null; }
  function openCartDrawer() {
    suppressUntil = 0; // an explicit open must not be cancelled by the guard
    var el = document.querySelector('#offcanvas-cart');
    if (el && bs('Offcanvas')) bs('Offcanvas').getOrCreateInstance(el).show();
  }
  function closeCartDrawer() {
    var el = document.querySelector('#offcanvas-cart');
    if (el && bs('Offcanvas')) bs('Offcanvas').getOrCreateInstance(el).hide();
  }

  /* ---------------------------------------------- add detection + suppression */

  var armedOpen = null;
  var baseline = 0;
  var pollTimer = null;
  var disarmTimer = null;
  var suppressUntil = 0;
  var qvLock = null; // a Quick view modal kept open until the add-ons popup closes

  function stopTimers() {
    if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
    if (disarmTimer) { clearTimeout(disarmTimer); disarmTimer = null; }
  }

  // Close the Quick view that the current add-ons popup belonged to (if any).
  function releaseQuickView() {
    if (!qvLock) return;
    var m = qvLock; qvLock = null;
    if (bs('Modal')) bs('Modal').getOrCreateInstance(m).hide();
  }

  function arm(openFn) {
    armedOpen = openFn;
    baseline = badgeCount();
    log('armed (ATC clicked). baseline =', baseline);
    stopTimers();
    var tries = 0;
    pollTimer = setInterval(function () {
      if (!armedOpen) { stopTimers(); return; }
      tries++;
      fetchCount().then(function (n) {
        if (armedOpen && n !== null && n > baseline) { log('poll detected add. count =', n); fire(); }
      });
      if (tries >= 25) { log('poll gave up'); armedOpen = null; qvLock = null; stopTimers(); }
    }, 300);
    disarmTimer = setTimeout(function () { armedOpen = null; qvLock = null; stopTimers(); }, 9000);
  }

  function fire() {
    if (!armedOpen) return;
    var open = armedOpen; armedOpen = null;
    stopTimers();
    suppressUntil = Date.now() + 2500;
    log('opening popup');
    open();
  }

  function onCartAdd() { if (armedOpen) { log('cart/add intercepted'); fire(); } }

  function wrapNetwork() {
    if (W.netWrapped) return; W.netWrapped = true;
    if (typeof window.fetch === 'function') {
      var of = window.fetch;
      window.fetch = function (input, init) {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var method = (init && init.method) || (input && input.method) || 'GET';
        var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url) && /post/i.test(method);
        var p = of.apply(this, arguments);
        if (isAdd) p.then(function (r) { if (!r || r.ok) onCartAdd(); }).catch(function () {});
        return p;
      };
    }
    var oOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__addonIsAdd = /post/i.test(method || '') && /\/cart\/add(\.js)?(\?|$)/.test(url || '');
      return oOpen.apply(this, arguments);
    };
    var oSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__addonIsAdd) this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) onCartAdd();
      });
      return oSend.apply(this, arguments);
    };
    log('network wrapped');
  }

  function bindCartGuard() {
    if (W.bound) return; W.bound = true;
    wrapNetwork();

    document.addEventListener('show.bs.offcanvas', function (e) {
      if (e.target && e.target.id === 'offcanvas-cart' && Date.now() < suppressUntil) {
        log('cancelled cart drawer open (suppressed)');
        e.preventDefault();
      }
    });

    // Keep a Quick view open while the add-ons flow is running; it closes when
    // the popup is dismissed (via releaseQuickView).
    document.addEventListener('hide.bs.modal', function (e) {
      if (qvLock && e.target === qvLock) {
        log('kept quick view open (add-ons flow)');
        e.preventDefault();
      }
    });

    // Detect any Add-to-cart click (page, sticky ATC, or Quick view) and arm the
    // add-ons popup that belongs to the same scope. Bound once, globally, so it
    // works even when the page had no add-ons block at load (e.g. the homepage).
    document.addEventListener('click', function (e) {
      var atc = e.target.closest && e.target.closest('[name="add"], .btn-atc');
      if (!atc) return;

      // Only the MAIN product's Add to cart (product page or Quick view) and the
      // sticky ATC open the add-ons popup. Product cards, cross-sells,
      // recommended products and cart upsells are different products: ignore.
      var block = null;
      if (atc.closest('#sticky-atc')) {
        var all = document.querySelectorAll('[data-product-addons][data-mode="modal"]');
        for (var i = 0; i < all.length; i++) {
          if (!all[i].closest('.modal, .offcanvas')) { block = all[i]; break; }
        }
      } else {
        var form = atc.closest('form');
        if (form) block = form.querySelector('[data-product-addons][data-mode="modal"]');
      }

      if (block && block._addonOpen) {
        qvLock = atc.closest('.modal'); // if inside Quick view, keep it open until popup closes
        log('ATC clicked; arming add-ons', qvLock ? '(quick view held open)' : '(page)');
        arm(block._addonOpen);
        return;
      }

      // Simple product added straight from a card: fetch that product's add-ons
      // block on demand and open its popup right here (no Quick view needed).
      var src = atc.closest('[data-addon-source]');
      if (src) {
        var url = src.getAttribute('data-addon-source');
        log('card quick-add; will fetch add-ons for', url);
        arm(function () { openFromUrl(url); });
        return;
      }

      log('ATC click ignored (not the main/sticky ATC, or no add-ons block)');
    });
  }

  // Fetch a product page, pull out its add-ons block, and open the popup here.
  function openFromUrl(url) {
    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var block = doc.querySelector('[data-product-addons][data-mode="modal"]');
        if (!block) { log('no add-ons for this product; opening cart'); suppressUntil = 0; openCartDrawer(); return; }

        var host = document.getElementById('addons-card-portal');
        if (!host) { host = document.createElement('div'); host.id = 'addons-card-portal'; document.body.appendChild(host); }
        host.innerHTML = '';

        // Bring the block's stylesheet along (it directly follows the block).
        var style = block.nextElementSibling;
        if (style && style.tagName === 'STYLE') host.appendChild(document.importNode(style, true));

        var imported = document.importNode(block, true);
        imported.removeAttribute('data-addons-ready');
        host.appendChild(imported);

        initRoot(imported);
        if (imported._addonOpen) { imported._addonOpen(); }
        else { suppressUntil = 0; openCartDrawer(); }
      })
      .catch(function () { suppressUntil = 0; openCartDrawer(); });
  }

  /* ------------------------------------------------------------- block set-up */

  function initRoot(root) {
    if (!root || root.dataset.addonsReady === '1') return;
    root.dataset.addonsReady = '1';
    bindCartGuard();

    var mode = root.dataset.mode || 'modal';
    var overlay = root.querySelector('[data-addon-overlay]');
    var closeOnAdd = root.dataset.closeOnAdd === 'true';
    var openCartOnAdd = root.dataset.openCartOnAdd === 'true';
    var addedText = root.dataset.addedText || 'Added';
    var addText = root.dataset.addText || 'Add';
    var mainForm = root.closest('form');
    log('init block. mode =', mode, 'items =', root.querySelectorAll('[data-addon-item]').length, 'form =', !!mainForm);

    if (overlay) overlay._addonRoot = root;

    function openOverlay() {
      if (!overlay) { log('no overlay element!'); return; }
      document.querySelectorAll('.addons-overlay--modal').forEach(function (o) {
        if (o === overlay) return;
        o.classList.remove('is-open'); o.hidden = true;
        if (o._addonRoot && !o._addonRoot.isConnected) o.remove();
      });
      var inModal = root.closest('.modal, .offcanvas');
      if (inModal && overlay.parentNode !== document.body) {
        overlay.style.cssText = root.getAttribute('style') || '';
        // Carry the block's stylesheet out too, so the popup keeps its styling
        // even if the Quick view markup is torn down underneath it.
        var st = root.nextElementSibling;
        if (st && st.tagName === 'STYLE') document.body.appendChild(st);
        document.body.appendChild(overlay);
      }
      overlay.hidden = false;
      void overlay.offsetWidth;
      overlay.classList.add('is-open');
      document.addEventListener('keydown', onEsc);
      log('overlay shown');
    }
    function closeOverlay() {
      if (!overlay) return;
      overlay.classList.remove('is-open');
      document.removeEventListener('keydown', onEsc);
      setTimeout(function () { if (!overlay.classList.contains('is-open')) overlay.hidden = true; }, 220);
      releaseQuickView(); // now that the popup is closed, close the Quick view (if any)
    }
    function onEsc(e) { if (e.key === 'Escape') closeOverlay(); }

    root.querySelectorAll('[data-addon-qty]').forEach(function (q) {
      var minus = q.querySelector('[data-addon-qty-minus]');
      var plus = q.querySelector('[data-addon-qty-plus]');
      var val = q.querySelector('[data-addon-qty-value]');
      function set(n) { if (n < 1) n = 1; q.dataset.qty = n; if (val) val.textContent = n; if (minus) minus.disabled = n <= 1; }
      if (plus) plus.addEventListener('click', function () { set((parseInt(q.dataset.qty, 10) || 1) + 1); });
      if (minus) minus.addEventListener('click', function () { set((parseInt(q.dataset.qty, 10) || 1) - 1); });
    });

    root.querySelectorAll('[data-addon-item]').forEach(function (item) {
      var btn = item.querySelector('[data-addon-add]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var variantEl = item.querySelector('[data-addon-variant]');
        var variantId = variantEl ? variantEl.value : null;
        if (!variantId) return;
        var qtyEl = item.querySelector('[data-addon-qty]');
        var qty = qtyEl ? (parseInt(qtyEl.dataset.qty, 10) || 1) : 1;
        btn.disabled = true; btn.classList.add('disabled');
        addToCart(variantId, qty)
          .then(function () { return refreshCart(); })
          .then(function () {
            btn.textContent = addedText; item.classList.add('is-added');
            if (openCartOnAdd) { closeOverlay(); openCartDrawer(); }
            else if (closeOnAdd) { closeOverlay(); }
            else { setTimeout(function () {
              btn.disabled = false; btn.classList.remove('disabled');
              btn.textContent = addText; item.classList.remove('is-added');
            }, 1500); }
          })
          .catch(function () { btn.disabled = false; btn.classList.remove('disabled'); btn.textContent = addText; });
      });
    });

    if (mode === 'modal' && overlay) {
      var closeBtn = overlay.querySelector('[data-addon-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
      var skip = overlay.querySelector('[data-addon-skip]');
      if (skip) skip.addEventListener('click', function () { closeOverlay(); openCartDrawer(); });
      overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });

      // The global ATC-click handler (bindCartGuard) opens this via _addonOpen.
      root._addonOpen = openOverlay;
    }
  }

  /* --------------------------------------------------------------- discovery */

  function scan() { document.querySelectorAll('[data-product-addons]').forEach(initRoot); }

  function start() {
    log('asset loaded');
    bindCartGuard(); // set up network intercept + ATC detection on every page, early
    scan();
    if ('MutationObserver' in window) {
      var p = null;
      new MutationObserver(function () {
        if (p) return;
        p = requestAnimationFrame(function () { p = null; scan(); });
      }).observe(document.body, { childList: true, subtree: true });
    }
    ['shown.bs.modal', 'shown.bs.offcanvas'].forEach(function (evt) { document.addEventListener(evt, scan); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
